import { render, staticRenderFns } from "./FlowObjectCustomTab.vue?vue&type=template&id=f2d757b6"
import script from "./FlowObjectCustomTab.vue?vue&type=script&lang=js"
export * from "./FlowObjectCustomTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports